import React, { Component } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { SFRTA_TrackAndTimeReportSchema } from "./SFRTA_TrackAndTimeReportSchema";

const ReportView = (props) => {
  let data = props.data ? props.data : {};

  let sectionsData = [{}, data, data.tbltes ? data.tbltes : [], [data]];
  sectionsData[2] = sectionsData[2].map((row) => {
    row._void = row.dispinit2 && row.timerel;
    row._limits = [
      {
        track: row.track,
        lbet1: row.lbet1,
        lsw1: row.lsw1,
        lbet2: row.lbet2,
        lsw2: row.lsw2,
      },
      {
        track: row.track2,
        lbet1: row.lbet3,
        lsw1: row.lsw3,
        lbet2: row.lbet4,
        lsw2: row.lsw4,
      }
    ];
    return row;
  });
  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection
        title={
          <div>
            <div>{"TRACK AND TIME FORM"}</div>
            <div style={{ fontWeight: 100 }}>{`(${props.title})`}</div>{" "}
          </div>
        }
        fontSizeOverride={"30px"}
        centerTitle={true}
      />
      <span className="spacer"></span>
      <table className="table-bordered">
        {SFRTA_TrackAndTimeReportSchema.sections.map((section, i) => {
          return <ReportTableSectionRenderer key={i} section={section} rowsData={sectionsData[i]} />;
        })}
      </table>
    </div>
  );
};

const SFRTA_TrackAndTimeForm = (props) => <ReportView {...props} />;

export default SFRTA_TrackAndTimeForm;



// WEBPACK FOOTER //
// ./src/components/Reports/SFRTA/TrackAndTimeForm/index.jsx